import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Calendar, PlayCircle, Newspaper } from "lucide-react";

const fmtDate = (iso) => { try { return new Date(iso).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" }); } catch { return ""; } };

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/posts").then((r) => setPosts(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="App">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-[112px] pb-24">
        <span className="text-primary font-bold text-xs tracking-[0.3em] uppercase">Blog & Vídeos</span>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter mt-3">Novidades do STAND LF</h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">Dicas de compra, financiamento, manutenção e as novidades das nossas viaturas.</p>

        {loading ? (
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(3)].map((_, i) => <div key={i} className="aspect-[16/11] rounded-3xl bg-muted animate-pulse" />)}
          </div>
        ) : posts.length === 0 ? (
          <div data-testid="blog-empty" className="text-center py-24 bg-secondary/40 rounded-3xl mt-12">
            <Newspaper className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <p className="font-heading font-bold text-xl">Ainda sem publicações</p>
            <p className="text-muted-foreground mt-2">Volte em breve para novidades e vídeos.</p>
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <Link key={p.id} to={`/blog/${p.id}`} data-testid="blog-card" className="group bg-white rounded-3xl overflow-hidden border border-black/5 hover:shadow-2xl hover:shadow-black/10 transition-shadow animate-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
                <div className="relative aspect-[16/10] overflow-hidden bg-gradient-to-br from-secondary to-accent/40">
                  {p.cover && <img src={fileUrl(p.cover)} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />}
                  {p.video_url && (
                    <span className="absolute inset-0 flex items-center justify-center">
                      <PlayCircle className="w-14 h-14 text-white drop-shadow-lg" />
                    </span>
                  )}
                </div>
                <div className="p-6">
                  <p className="text-xs text-muted-foreground flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-primary" /> {fmtDate(p.created_at)}</p>
                  <h3 className="font-heading font-bold text-xl tracking-tight mt-2 line-clamp-2">{p.title}</h3>
                  {p.excerpt && <p className="text-muted-foreground text-sm mt-2 line-clamp-2">{p.excerpt}</p>}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
